import React from "react";
import Chart from "react-apexcharts";
import { COLORES_EVOLUCION } from "./constants";
import { formatCurrency, formatMontoEje } from "./utils";

export default function GraficoEvolucionCompra(props) {
    const moneda = props.moneda || "PEN";

    const options = {
        chart: {
            type: "line",
            toolbar: { show: false },
            zoom: { enabled: false },
        },
        colors: COLORES_EVOLUCION,
        // Periodo actual en linea continua y el anterior punteado, como
        // referencia de comparacion.
        stroke: { width: [3, 2], curve: "smooth", dashArray: [0, 5] },
        markers: { size: 0, hover: { size: 5 } },
        dataLabels: { enabled: false },
        xaxis: {
            categories: props.timeLine || [],
            tickAmount: 10,
        },
        yaxis: {
            min: 0,
            labels: { formatter: formatMontoEje },
        },
        tooltip: {
            shared: true,
            y: { formatter: (val) => formatCurrency(val, moneda) },
        },
        legend: {
            position: "top",
            horizontalAlign: "left",
        },
        noData: { text: "Sin compras en el periodo" },
    };

    return (
        <Chart options={options} series={props.series || []} type="line" height={320} />
    );
}
